<div class="body-content">
  @if (customerForm && customerForm.controls) {
    <form [formGroup]="customerForm" class="feedback-form" (ngSubmit)="submitForm()">
      <app-scrollable class="feedback-questions">
        @for (question of surveyJsonForm.customerSurvey.survey; track question) {
          @if (customerForm.controls[question.uniqueId]) {
            @switch (question.type) {
              @case ('toggle') {
                <div class="feedback-card feedback-card--row">
                  <span class="feedback-question-text">{{ question.text }}</span>
                  <div class="feedback-toggle-group">
                    <app-toggle [formControlName]="question.uniqueId" color="mint"></app-toggle>
                    <span class="feedback-toggle-value">
                      {{ (customerForm.get(question.uniqueId)?.value ? 'GLOBAL.OUI' : 'GLOBAL.NON') | translate }}
                    </span>
                  </div>
                </div>
                <div class="feedback-separator"></div>
              }
              @case ('2scale') {
                <div class="feedback-card">
                  <app-scale [form]="customerForm" [question]="question"></app-scale>
                </div>
                <div class="feedback-separator"></div>
              }
              @case ('3scale') {
                <div class="feedback-card">
                  <app-scale [form]="customerForm" [question]="question"></app-scale>
                </div>
                <div class="feedback-separator"></div>
              }
              @case ('dropdown') {
                <div class="feedback-card feedback-card--row">
                  <span class="feedback-question-text">{{ question.text }}</span>
                  <ng-select class="feedback-dropdown" [formControlName]="question.uniqueId"
                    [items]="dropDownItemsMap[question.uniqueId]" bindLabel="text" bindValue="id"
                    [multiple]="false" [clearable]="false" [searchable]="true">
                  </ng-select>
                </div>
                <div class="feedback-separator"></div>
              }
              @case ('date') {
                <div class="feedback-card feedback-card--row">
                  <span class="feedback-question-text">{{ question.text }}</span>
                  <input type="text" [formControlName]="question.uniqueId"
                    class="feedback-input" [matDatepicker]="customerDatePicker"
                    onkeydown="return false" readonly autocomplete="off"
                    (click)="customerDatePicker.open()" (focus)="customerDatePicker.open()"/>
                  <mat-datepicker #customerDatePicker></mat-datepicker>
                </div>
                <div class="feedback-separator"></div>
              }
              @case ('number') {
                <div class="feedback-card feedback-card--row">
                  <span class="feedback-question-text">{{ question.text }}</span>
                  <input #inputNumber [formControlName]="question.uniqueId" type="number"
                    class="feedback-input"/>
                </div>
                <div class="feedback-separator"></div>
              }
              @case ('freeText') {
                <div class="feedback-card feedback-card--freetext">
                  <span class="feedback-freetext-label">{{ question.text }}</span>
                  <div class="feedback-textarea-wrapper">
                    <textarea [formControlName]="question.uniqueId"
                      [attr.maxlength]="question.max_length"
                      class="feedback-textarea"
                      rows="4">
                    </textarea>
                    <span class="feedback-char-count">
                      {{ (customerForm.get(question.uniqueId)?.value?.length ?? 0) }}/{{ question.max_length }}
                    </span>
                  </div>
                </div>
                <div class="feedback-separator"></div>
              }
            }
          }
        }
      </app-scrollable>
      <div class="feedback-actions">
        <app-button
          variant="secondary"
          color="amarante"
          [label]="'SURVEY.CANCEL' | translate"
          (clicked)="rechargerDonnees.emit(false)">
        </app-button>
        <app-button
          htmlType="submit"
          variant="primary"
          color="amarante"
          [addIconLeft]="true"
          [label]="'SURVEY.SUBMIT' | translate"
          [state]="customerForm.pristine ? 'disabled' : 'default'">
          <i slot="icon-left" class="fas fa-save"></i>
        </app-button>
      </div>
    </form>
  }
</div>
